import React from 'react';
import ReactDOM from 'react-dom';
import Root from 'pages/Root';

ReactDOM.render(<Root />, document.getElementById('root'));
